import { StateDropDown } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';

export const State: React.FC = () => {
    const state = usePaymentStore((s) => s.state);
    const set_state = usePaymentStore((s) => s.set_state);

    return (
        <StateDropDown
            id='card-billing-state'
            value={state}
            onChange={(value) => set_state(value)}
            label='State'
            required={true}
        />
    );
};
